import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBiSaMD9mwPT_2aRMBVHux2dzviUvQi97U",
  authDomain: "swshpipeline.firebaseapp.com",
  projectId: "swshpipeline",
  storageBucket: "swshpipeline.firebasestorage.app",
  messagingSenderId: "802843409010",
  appId: "1:802843409010:web:c083f4c4b29f7dc707e0eb",
  measurementId: "G-NHZVYG1KXL"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Firestore 초기화
const db = getFirestore(app);

// Authentication 초기화
const auth = getAuth(app);

// Storage 초기화
const storage = getStorage(app);

export { db, auth, storage };
